import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useCallback, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { defaultCustomProduct } from 'shared/constants';
import { useQuoteState } from 'shared/contexts';
import { TCustomProductForm } from 'shared/types';
import { NewCustomProductDialogFields } from './new-custom-product-dialog-fields';

export function NewCustomProductDialog() {
  const { newCustomProductDialogOpen, toggleNewCustomProductDialog, setTempCustomProduct } = useQuoteState();

  const methods = useForm<TCustomProductForm>({
    defaultValues: defaultCustomProduct,
  });
  const { handleSubmit, reset } = methods;

  const onClose = useCallback(() => {
    toggleNewCustomProductDialog();
  }, [toggleNewCustomProductDialog]);

  const onSubmit = useCallback(
    (data: TCustomProductForm) => {
      setTempCustomProduct(data);
      onClose();
    },
    [setTempCustomProduct, onClose]
  );

  useEffect(() => {
    reset(defaultCustomProduct);
  }, [newCustomProductDialogOpen, reset]);

  return (
    <Dialog open={newCustomProductDialogOpen} onClose={onClose}>
      <DialogTitle>Add Custom Product</DialogTitle>
      <DialogContent>
        <FormProvider {...methods}>
          <form aria-label='form' id='new-product-form' onSubmit={handleSubmit(onSubmit)}>
            <NewCustomProductDialogFields />
          </form>
        </FormProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button type='submit' form='new-product-form' color='secondary' variant='contained'>
          Add Custom Product
        </Button>
      </DialogActions>
    </Dialog>
  );
}
